(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("OrganizationChart", [], factory);
	else if(typeof exports === 'object')
		exports["OrganizationChart"] = factory();
	else
		root["OrganizationChart"] = factory();
})(this, function() {
return 